import React from 'react';
import PropTypes from 'prop-types';

import TeamIcon from '../shared/TeamIcon';
import UserIcon from '../shared/UserIcon';

const TeamListItem = ({
  text,
  itemId,
  selected,
  handleSelection,
  handleExpendTree,
  listid,
  children,
  position,
}) => {
  const handleItemSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey);
  };

  const renderChildren = () => {
    const renderChild = _.map(children, user => {
      return (
        <li key={`user_${user.userId}`} id={`user_${user.userId}`}>
          <UserIcon size="18px" fill="#b2bece" /> <span>{`${user.firstName} ${user.lastName}`}</span> <span className="user-email">{user.emailLogin}</span>
        </li>
      );
    });

    return (
      <div className="dropdown-menu-children">
        <ul className="dropdown-items">
          {renderChild}
        </ul>
      </div>
    );
  };


  const hasChild = !_.isEmpty(children);
  let toggleIcon = String.fromCharCode(9658);
  if (hasChild) {
    toggleIcon = String.fromCharCode(9660);
  }
  return (
    <li
      onMouseDown={handleItemSelection}
      id={itemId}
      className={selected ? 'dropdown-menu-multi-select active' : 'dropdown-menu-multi-select'}
    >
      <div className="dropdown-menu-item">
        <button className="expend-tree-button" onClick={e => handleExpendTree(e, listid, hasChild, position)}>
          <span className="icon">{toggleIcon}</span>
        </button>
        <a><TeamIcon size="18px" fill="#b2bece" /> <span className="menu-text">{text}</span></a>
      </div>
      {hasChild && renderChildren()}
    </li>
  );
};


TeamListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  itemId: PropTypes.number,
  selected: PropTypes.bool,
  listid: PropTypes.number,
  position: PropTypes.string,
  handleExpendTree: PropTypes.func,
  children: PropTypes.instanceOf(Array),
};

export default TeamListItem;
